import { addDays, endOfDay, isWithinInterval, min, startOfDay } from 'date-fns';

import { Zeitraum } from '../../dtos';

export function ablaufStartsWithin11DaysAfterDate(ablauf: Zeitraum[], date: Date): boolean {
  if (ablauf.length === 0) {
    throw new Error('ablauf array is empty');
  }

  const start = min(ablauf.map(({ start }) => start));
  return isWithinInterval(start, {
    start: startOfDay(date),
    end: endOfDay(addDays(date, 11)),
  });
}
